<template>
  <label class="estado" :class="[
      { [`estado-${label.toLowerCase()}`]: type },
    ]">
    {{ label.replace('_',' ').toUpperCase() }}
  </label>
</template>
<script>
  export default {
    name: 'estado',
    props: {
      label: [String],
      type: {
        type: String,
        default: 'primary',
        description: 'Tipo Estado(primary|secondary|danger etc)'
      }
    },
    data () {
      return {
      }
    },
    mounted(){
    },
    computed: {
    },
    created () {
    }
  }
</script>

<style lang="scss" scoped>
.estado {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
}
</style>
